export default class LevelNumberTab {
  constructor(game, parent, initialWidth, initialHeight, showLevelAsHard, levelNumber) {
    // imports
    this._showHardLevel = showLevelAsHard;
    this._UI = G.UI;
    const getJson = function getJson(key) { return G.json[key]; };

    // json thing
    this._uiElement = this._UI.createUIElement(
      game,
      getJson('ui/board/levelNumberTab'),
      1, 1,
      getJson,
      this._filterVariant.bind(this),
    );

    this._setText(this._uiElement.exports, 'text_level', levelNumber.toString());

    parent.add(this._uiElement.rootElement);
    this._UI.resize(this._uiElement.rootElement, initialWidth, initialHeight);

    this._slidedIn = false;
    this._positionAnimator = this._doCreatePositionAnimator(
      this._uiElement.exports.getFirst('moveable').rootElement,
      this._uiElement.exports.getFirst('helper_animate_source_position').rootElement,
    );
  }

  _filterVariant(exportNames) {
    if (this._showHardLevel && exportNames.indexOf('variant_normal') >= 0) return false;
    if (!this._showHardLevel && exportNames.indexOf('variant_hard') >= 0) return false;
    return true;
  }

  _setText(exports, exportName, textValue) {
    exports.forEvery(exportName, (element) => {
      element.setText(textValue);
    });
  }

  _doCreatePositionAnimator(moveable, hiddenPosObject) {
    const { createPositionAnimator } = G.AnimationUtils;
    const positionAnimator = createPositionAnimator(game, moveable, true, 'visible');
    positionAnimator.addPosition('hidden', hiddenPosObject);
    positionAnimator.setPosition('hidden');
    return positionAnimator;
  }

  animateSlideIn() {
    this._slidedIn = true;
    this._positionAnimator.animateToPosition('visible');
  }

  animateSlideOut() {
    this._slidedIn = false;
    this._positionAnimator.animateToPosition('hidden');
  }

  resize(width, height) {
    this._UI.resize(this._uiElement.rootElement, width, height);
    // HACK: resize resets position of rootElement which was previously set to 'hidden'
    if (!this._slidedIn) {
      this._positionAnimator.setPosition('hidden');
    }
  }
}
